<section class="aic-feature-section py-5">
  <div class="container py-lg-5">
    <div class="row justify-content-center text-center mb-4 mb-lg-5">
      <div class="col-lg-8">
        <p class="text-danger text-uppercase fw-bold small mb-2">Portfolio intelligence</p>
        <h2 class="display-6 fw-bold text-dark mb-3">
          Built for property teams who need the full picture quickly.
        </h2>
        <p class="lead text-secondary mb-0">
          AI Campus Data Intelligence brings operational data into a focused workspace for monitoring, comparison, and faster response.
        </p>
      </div>
    </div>

    <div class="row g-4">
      <div v-for="feature in feature_cards" :key="feature.title" class="col-md-6 col-xl-4">
        <article class="card h-100 border rounded-4 bg-light shadow-sm">
          <div class="card-body d-flex align-items-start gap-3 p-4">
            <span class="d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-4 bg-danger-subtle text-danger fs-2 p-3">
              <i class="lh-1" :class="feature.icon"></i>
            </span>
            <div>
              <h3 class="h5 fw-bold text-dark mb-2">{{ feature.title }}</h3>
              <p class="text-secondary lh-base mb-0">{{ feature.text }}</p>
            </div>
          </div>
        </article>
      </div>
    </div>

    <div class="row g-4 align-items-center mt-4 mt-lg-5">
      <div class="col-lg-6">
        <div class="ratio ratio-16x9 rounded-3 overflow-hidden shadow-lg aic-feature-visual">
          <div class="d-flex flex-column justify-content-between p-4">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p class="text-white-50 text-uppercase fw-bold small mb-1">Live portfolio</p>
                <h3 class="text-white fw-bold mb-0">Operational overview</h3>
              </div>
              <span class="badge rounded-pill text-bg-light">Online</span>
            </div>

            <div class="row g-3">
              <div class="col-4">
                <div class="bg-white bg-opacity-10 rounded-3 p-3">
                  <span class="d-block text-white-50 small">Utilities</span>
                  <strong class="text-white fs-4">12</strong>
                </div>
              </div>
              <div class="col-4">
                <div class="bg-white bg-opacity-10 rounded-3 p-3">
                  <span class="d-block text-white-50 small">Alerts</span>
                  <strong class="text-white fs-4">03</strong>
                </div>
              </div>
              <div class="col-4">
                <div class="bg-white bg-opacity-10 rounded-3 p-3">
                  <span class="d-block text-white-50 small">Sites</span>
                  <strong class="text-white fs-4">08</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <p class="text-danger text-uppercase fw-bold small mb-2">How it helps</p>
        <h3 class="fw-bold text-dark mb-3">Less switching, more signal.</h3>
        <p class="text-secondary mb-4">
          The platform is shaped around the information property teams repeatedly check: current status, exceptions, and portfolio-level movement.
        </p>
        <div class="d-flex flex-wrap gap-2">
          <span class="badge rounded-pill text-bg-light border px-3 py-2">Utilities</span>
          <span class="badge rounded-pill text-bg-light border px-3 py-2">Security</span>
          <span class="badge rounded-pill text-bg-light border px-3 py-2">Connectivity</span>
          <span class="badge rounded-pill text-bg-light border px-3 py-2">Consumption</span>
        </div>
      </div>
    </div>
  </div>
</section>
